document.addEventListener('DOMContentLoaded', () => {
	initCaseStudiesSliders();
});

const MOBILE_BREAKPOINT = 1024;

const initCaseStudiesSliders = () => {
	const sections = document.querySelectorAll('.js-case-studies-slider');

	if (!sections.length) return;

	sections.forEach(section => {
		const slidesContainer = section.querySelector('.case-studies-slider__slides');
		const slides  = Array.from(section.querySelectorAll('.js-case-studies-slide'));
		const prevBtn = section.querySelector('.js-case-studies-prev');
		const nextBtn = section.querySelector('.js-case-studies-next');

		if (!slides.length) return;

		let current = 0;
		let isAnimating = false;
		let scrollTimeout = null;

		const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

		const updateNavState = () => {
			if (!prevBtn || !nextBtn) return;
			prevBtn.classList.toggle('is-disabled', current === 0);
			nextBtn.classList.toggle('is-disabled', current === slides.length - 1);
		};

		const goTo = (index) => {
			if (isAnimating) return;
			isAnimating = true;

			slides.forEach((slide, i) => {
				slide.classList.toggle('is-active', i === index);
			});
			current = index;
			updateNavState();

			if (isMobile() && slidesContainer) {
				slidesContainer.scrollTo({
					left: slides[index].offsetLeft,
					behavior: 'smooth'
				});
			}

			setTimeout(() => {
				isAnimating = false;
			}, 650);
		};

		if (slidesContainer) {
			slidesContainer.addEventListener('scroll', () => {
				if (!isMobile()) return;

				clearTimeout(scrollTimeout);
				scrollTimeout = setTimeout(() => {
					const scrollLeft = slidesContainer.scrollLeft;
					const containerWidth = slidesContainer.offsetWidth;
					const newIndex = Math.round(scrollLeft / containerWidth);

					if (newIndex !== current && newIndex >= 0 && newIndex < slides.length) {
						current = newIndex;
						slides.forEach((slide, i) => {
							slide.classList.toggle('is-active', i === current);
						});
						updateNavState();
					}
				}, 100);
			});
		}

		goTo(0);

		if (prevBtn) {
			prevBtn.addEventListener('click', () => {
				if (current > 0) goTo(current - 1);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', () => {
				if (current < slides.length - 1) goTo(current + 1);
			});
		}

		slides.forEach((slide, i) => {
			slide.addEventListener('click', () => {
				if (!isMobile() && i !== current) goTo(i);
			});
		});
	});
};
